import api from '../../index'

export interface FontPackageFileEntity {
  id: string
  original_name?: string
  extension?: string
  size?: number
  full_url?: string
  url?: string
}

export interface FontPackageEntity {
  id: string
  name: string
  file_id: string
  is_title?: boolean | number
  is_extra?: boolean | number
  is_signature?: boolean | number
  font_url?: string
  created_at?: string
  updated_at?: string
  file?: FontPackageFileEntity | null
}

function resolveApiBaseUrl(): string {
  const base = (api.defaults.baseURL ?? '').toString().trim()
  if (!base) {
    return '/api/admin'
  }

  return base.replace(/\/$/, '')
}

export function getFontPackageFileUrl(id: string): string {
  const fontId = (id ?? '').toString().trim()
  if (!fontId) {
    return ''
  }

  const base = resolveApiBaseUrl()
  return `${base}/FontPackage/getFontPackageFile?id=${encodeURIComponent(fontId)}`
}

export default {
  getFontPackageList: (params: any = {}): Promise<{ data: any }> => {
    return api.get('/FontPackage/getFontPackageList', { params })
  },

  getFontPackageDetail: (id: string): Promise<{ data: any }> => {
    return api.get('/FontPackage/getFontPackageDetail', { params: { id } })
  },

  createFontPackage: (data: FormData): Promise<{ data: any }> => {
    return api.post('/FontPackage/createFontPackage', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  updateFontPackage: (data: FormData): Promise<{ data: any }> => {
    return api.post('/FontPackage/updateFontPackage', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  deleteFontPackage: (id: string): Promise<{ data: any }> => {
    return api.post('/FontPackage/deleteFontPackage', { id })
  },
}
